<script>
  import { format } from 'svelte-i18n';

  import { isLeafNode, parseCssVariables } from './utils';
  import VariableGroup from './variable-group.svelte';

  /** @type {Record<string, string>} */
  export let variables = {};

  /** @type {(name: string, value: string) => void} */
  export let onChange = (name, value) => {};

  const handleMessage = (e) => {
    if (e.data?.source === 'card') {
      const { target } = e.data;

      if (target) {
        const element = document.getElementById(target);

        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });

          element.classList.add('highlight-scroll-target');

          setTimeout(() => {
            element.classList.remove('highlight-scroll-target');
          }, 2000);
        }
      }
    }
  };

  $: hasCommonVariables = Object.values(variableTree).some(isLeafNode);
  $: variableTree = Object.keys(variables).length ? parseCssVariables(variables) : {};
</script>

{#if Object.keys(variables).length}
  {#if hasCommonVariables}
    <h2>{$format('label.THEME')}</h2>
    <div class="px-3 py-3 pb-2">
      <div>
        {#each Object.entries(variableTree) as [key, node]}
          {#if isLeafNode(node)}
            <VariableGroup nodeData={node} nodeKey={key} level={2} {onChange} />
          {/if}
        {/each}
      </div>
    </div>
  {/if}
  {#each Object.entries(variableTree) as [key, node]}
    {#if !isLeafNode(node)}
      <h2>{key.replaceAll('_', ' ')}</h2>
      <div class="px-3 py-3 pb-2" id={key}>
        <div>
          <VariableGroup nodeData={node} nodeKey={key} level={2} {onChange} />
        </div>
      </div>
    {/if}
  {/each}
{/if}

<svelte:window on:message={handleMessage} />

<style lang="scss" src="./variables.scss"></style>
